import { render, staticRenderFns } from "./TestReport.vue?vue&type=template&id=1cf5fc80&scoped=true"
import script from "./TestReport.vue?vue&type=script&lang=js"
export * from "./TestReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf5fc80",
  null
  
)

export default component.exports